'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

/** Dimensions intrinsèques du logo bannière (logo_rose.png). */
const LOGO_INTRINSIC_WIDTH = 1045;
const LOGO_INTRINSIC_HEIGHT = 303;

/** Hauteur compacte — nav + pages publiques (mobile & desktop). */
export const APP_LOGO_HEIGHT = 28;

interface AppLogoProps {
  src?: string; // Image source (optional)
  iconName?: string; // Icon name when no image
  /** Hauteur cible en px (largeur calculée automatiquement). */
  size?: number;
  className?: string; // Additional classes
  onClick?: () => void; // Click handler
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/logo_rose.png',
  iconName = 'SparklesIcon',
  size = APP_LOGO_HEIGHT,
  className = '',
  onClick,
}: AppLogoProps) {
  // Memoize className calculation
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className && !src) classes.push(className);
    return classes.join(' ');
  }, [onClick, className, src]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {/* Show image if src provided, otherwise show icon */}
      {src ? (
        <AppImage
          src={src}
          alt="Logo"
          width={LOGO_INTRINSIC_WIDTH}
          height={LOGO_INTRINSIC_HEIGHT}
          className={`flex-shrink-0 w-auto object-contain ${className}`}
          style={{ height: size, width: 'auto', maxWidth: 'none' }}
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
